module.exports = __webpack_public_path__ + "img/weather-station.c127637d.svg";